import Nullstack from 'nullstack';
export default function IconAdjustmentsOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-adjustments-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "10",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M6 6v2"
  }), "   ", Nullstack.element("path", {
    d: "M6 12v8"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "16",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M12 4v4"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v2"
  }), "   ", Nullstack.element("path", {
    d: "M12 18v2"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "7",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M18 4v1"
  }), "   ", Nullstack.element("path", {
    d: "M18 9v5"
  }), "   ", Nullstack.element("path", {
    d: "M18 18v2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}